import React from "react";
import { Helmet } from "react-helmet";

const HomeSEO = () => {
  return (

      <Helmet>
        <title>Betpro Wallet - Best Online Betting Platform in Pakistan</title>
        <link rel="icon" href="https://betprowallet.net/favicon.ico" />


   <link rel="canonical" href="https://betprowallet.net/home" />

        <meta name="description" content="Betpro Wallet is the best online betting platform in Pakistan. ⚽️ Sign up for free, bet on sports, and get a sign-up bonus. ✅ Easy deposits, secure withdrawals, and win big today at Betprowallet.net." />
        <meta name="keywords" content="Betpro Wallet, online betting in Pakistan, sports betting, Betpro Wallet Pakistan, best betting platform, Betpro Wallet registration, Betpro Wallet sign up bonus, Betprowallet.net" />
        <meta name="author" content="Betpro Wallet" />
        <meta property="og:title" content="Betpro Wallet - Best Online Betting Platform in Pakistan" />
        <meta property="og:description" content="Join Betpro Wallet, Pakistan's most trusted betting platform. Bet on sports, enjoy bonuses, and win big with safe and easy transactions." />
        <meta property="og:url" content="https://betprowallet.net/home" />
        <meta property="og:type" content="website" />
        <meta property="og:image" content="https://betprowallet.net/bpthumb1.jpg" />


        <script type="application/ld+json">
          {`
            {
              "@context": "https://schema.org",
              "@type": "Website",
              "name": "Betpro Wallet - Best Online Betting Platform in Pakistan",
              "url": "https://betprowallet.net/home",
              "description": "Betpro Wallet is the leading online betting platform in Pakistan. Sign up today and get a welcome bonus to start betting on your favorite sports.",
              "publisher": {
                "@type": "Organization",
                "name": "Betpro Wallet"
              }
            }
          `}
        </script>
      </Helmet>

  );
};

export default HomeSEO;
